import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import {
  TextField,
  PhoneField,
} from '@roc/ui';
import { isNotBlank } from '@roc/feature-utils';

const NewPointOfContactForm = observer(({ store }) => {
  const formFields = store.pointOfContactFormStore?.form.fields;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <TextField
          testId="firstName"
          required
          standaloneLabel
          variant="outlined"
          label="First Name"
          value={formFields.firstName.value}
          onChange={e => store.pointOfContactFormStore.onFieldChange('firstName', e.target.value)}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          error={isNotBlank(formFields.firstName.error)}
          helperText={formFields.firstName.error}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          testId="lastName"
          standaloneLabel
          required
          variant="outlined"
          label="Last Name"
          value={formFields.lastName.value}
          onChange={e => store.pointOfContactFormStore.onFieldChange('lastName', e.target.value)}
          error={isNotBlank(formFields.lastName.error)}
          helperText={formFields.lastName.error}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <PhoneField
          testId="phone"
          required
          variant="outlined"
          standaloneLabel
          label="Cellphone number"
          value={formFields.phone.value}
          onChange={(name, value) => store.pointOfContactFormStore.onFieldChange('phone', value.match(/\d+/g) ? value.match(/\d+/g).join('') : '')}
          error={isNotBlank(formFields.phone.error)}
          errorText={formFields.phone.error}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          testId="email"
          required
          variant="outlined"
          standaloneLabel
          label="Email"
          value={formFields.email.value}
          onChange={e => store.pointOfContactFormStore.onFieldChange('email', e.target.value)}
          error={isNotBlank(formFields.email.error)}
          helperText={formFields.email.error}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </Grid>)
});

export default NewPointOfContactForm;